export default __webpack_public_path__ + "static/media/ultrabg.10f732de.png";